import { FC, useState, useRef } from 'react';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import Container from '@shared/Container';
import { getServiceId } from '@utils/searchbar/getServiceId';
import FlightSearchBar from '@domain/flight/searchBar';
import HotelSearchBar from '@domain/hotel/searchBar';
import TourSearchBar from '@domain/tour/searchBar';
import { TabletWrapper } from '@utils/styledForDisplay';
import CarSearchBar from '@domain/carRental/searchBar';
// import CruiseSearchBar from '@domain/cruise/searchBar';

import TabMenu from './tabMenu';
import {
  Wrapper,
  Title,
  Center,
  TabWrapper,
  TabItemWrapper,
  TabMenuWrapper,
  TabItemSubWrapper,
  TabMenuScroll,
  ScrollButtonLeft,
  ScrollButtonRight,
} from './styled';

export type ServiceType = 'flight' | 'hotel' | 'tour' | 'cruise' | 'carRental';

type PropsType = {
  fullContent?: boolean;
  activeService?: ServiceType;
  title?: string;
};

const SearchBar: FC<PropsType> = ({
  fullContent,
  activeService = 'flight',
  title = '',
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const [tabValue, setTabValue] = useState<number>(getServiceId(activeService));

  const tabChange = (id: number) => {
    setTabValue(id);
  };

  const scroll = (scrollOffset: number) => {
    if (ref.current != null) {
      ref.current.scrollLeft += scrollOffset;
    }
  };

  return (
    <Wrapper>
      {fullContent && (
        <Center>
          <Title>{title}</Title>
        </Center>
      )}
      <Container maxWidth='lg'>
        <TabWrapper>
          <TabMenuWrapper ref={ref}>
            <TabMenu onTabChange={tabChange} defaultTabId={tabValue} />
          </TabMenuWrapper>
          <TabletWrapper display='block'>
            <TabMenuScroll>
              <ScrollButtonLeft onClick={() => scroll(-100)}>
                <LeftOutlined />
              </ScrollButtonLeft>
              <ScrollButtonRight onClick={() => scroll(100)}>
                <RightOutlined />
              </ScrollButtonRight>
            </TabMenuScroll>
          </TabletWrapper>
        </TabWrapper>
        <TabItemWrapper>
          <TabItemSubWrapper tabValue={tabValue}>
            {tabValue === 1 && <FlightSearchBar />}
            {tabValue === 2 && <HotelSearchBar />}
            {tabValue === 3 && <TourSearchBar />}
            {tabValue === 5 && <CarSearchBar />}
            {/* {tabValue === 4 && <CruiseSearchBar />} */}
          </TabItemSubWrapper>
        </TabItemWrapper>
      </Container>
    </Wrapper>
  );
};

export default SearchBar;
